module.exports = __webpack_public_path__ + "static/media/delivery-carrefour.8c94980c.png";